<!-- 召回通知单列表 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
               <v-tabs :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm">
                  <template slot="tabs">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                           ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                           <el-row v-if="dataActionBox.actionType != 2">
                              <el-form-item prop="cmCode" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('单位编号')"
                                    v-html="$common.htmlLabel('单位编号')"></label>
                                 <el-input readonly v-model="sendDataInfo.cmCode" class="form_codition"></el-input>
                              </el-form-item>
                              <el-form-item prop="cmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('单位名称')"
                                    v-html="$common.htmlLabel('单位名称')"></label>
                                 <el-input @clear="clearChange" clearable v-model="sendDataInfo.cmName"
                                    @keyup.enter.native="openSearch(3391151360249856, 0, 'cmName', 'cmName,cmId,cmCode,cmLevel')">
                                    <el-button
                                       @click="openSearch(3391151360249856, 0, 'cmName', 'cmName,cmId,cmCode,cmLevel')"
                                       slot="append" icon="el-icon-search">
                                    </el-button>
                                 </el-input>
                              </el-form-item>
                              <el-form-item prop="authStart" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('起始日期')"
                                    v-html="$common.htmlLabel('起始日期')"></label>
                                 <el-date-picker class="form_codition" size="mini" v-model="sendDataInfo.authStart"
                                    format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                                 </el-date-picker>
                              </el-form-item>
                              <el-form-item prop="authEnd" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('结束日期')"
                                    v-html="$common.htmlLabel('结束日期')"></label>
                                 <el-date-picker class="form_codition" size="mini" v-model="sendDataInfo.authEnd"
                                    @change="changeTime" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                    placeholder="选择日期">
                                 </el-date-picker>
                              </el-form-item>
                           </el-row>
                           <el-row v-else>
                              <el-form-item prop="cmCode" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('单位编号')"
                                    v-html="$common.htmlLabel('单位编号')"></label>
                                 <el-input readonly v-model="sendDataInfo.cmCode" class="form_codition"></el-input>
                              </el-form-item>
                              <el-form-item prop="cmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('单位名称')"
                                    v-html="$common.htmlLabel('单位名称')"></label>
                                 <el-input readonly clearable v-model="sendDataInfo.cmName"></el-input>
                              </el-form-item>
                              <el-form-item prop="authStart" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('起始日期')"
                                    v-html="$common.htmlLabel('起始日期')"></label>
                                 <el-date-picker readonly class="form_codition" size="mini"
                                    v-model="sendDataInfo.authStart" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                                    type="date" placeholder="选择日期">
                                 </el-date-picker>
                              </el-form-item>
                              <el-form-item prop="authEnd" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('结束日期')"
                                    v-html="$common.htmlLabel('结束日期')"></label>
                                 <el-date-picker readonly class="form_codition" size="mini"
                                    v-model="sendDataInfo.authEnd" @change="changeTime" format="yyyy 年 MM 月 dd 日"
                                    value-format="timestamp" type="date" placeholder="选择日期">
                                 </el-date-picker>
                              </el-form-item>
                           </el-row>
                        </el-form>
                        <el-form class="baseForm" id="mainInfo1" label-width="100px" :model="sendDataInfo"
                           ref="sendDataInfo1" size="mini" :show-message="false" :inline-message="false">
                           <el-form-item prop="customerName" :rules="[{ required: true, trigger: ['blur', 'change'] }]"
                              v-if="sendDataInfo.cmLevel == '一级'">
                              <label slot="label" :style="$common.labelStyle('终端公司')"
                                 v-html="$common.htmlLabel('终端公司')"></label>
                              <div id="manrange">
                                 <div class="cmContent">
                                    <el-button v-if="dataActionBox.actionType != 2" class="cmButton"
                                       @click="openRange('终端公司', 'customer')" type="info" plain
                                       size="mini">选择终端公司</el-button>
                                    <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.customerName"
                                       readonly>
                                    </el-input>
                                 </div>
                              </div>
                           </el-form-item>
                           <el-form-item prop="brandName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                              <label slot="label" :style="$common.labelStyle('品牌')"
                                 v-html="$common.htmlLabel('品牌')"></label>
                              <div id="manrange">
                                 <div class="cmContent">
                                    <el-button v-if="dataActionBox.actionType != 2" class="cmButton"
                                       @click="openRange('品牌', 'manrange')" type="info" plain
                                       size="mini">选择品牌</el-button>
                                    <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.brandName"
                                       readonly>
                                    </el-input>
                                 </div>
                              </div>
                           </el-form-item>
                           <el-form-item prop="hospitalName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                              <label slot="label" :style="$common.labelStyle('医院')"
                                 v-html="$common.htmlLabel('医院')"></label>
                              <div class="cmContent">
                                 <el-button v-if="dataActionBox.actionType != 2" class="cmButton"
                                    @click="openRange('医院', 'manrange')" type="info" plain size="mini">选择医院</el-button>
                                 <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.hospitalName"
                                    readonly>
                                 </el-input>
                              </div>
                           </el-form-item>
                           <el-form-item prop="areaName">
                              <label slot="label" :style="$common.labelStyle('医院区域')"
                                 v-html="$common.htmlLabel('医院区域')"></label>
                              <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.areaName" readonly>
                              </el-input>
                           </el-form-item>
                           <el-form-item prop="bgiRegistno" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                              <label slot="label" :style="$common.labelStyle('注册证号')"
                                 v-html="$common.htmlLabel('注册证号')"></label>
                              <div class="cmContent">
                                 <el-button v-if="dataActionBox.actionType != 2" class="cmButton"
                                    @click="openRange('注册证', 'manrange')" type="info" plain
                                    size="mini">选择注册证</el-button>
                                 <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.bgiRegistno"
                                    readonly>
                                 </el-input>
                              </div>
                           </el-form-item>
                           <el-form-item prop="bgiRegistname"
                              :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                              <label slot="label" :style="$common.labelStyle('注册名称')"
                                 v-html="$common.htmlLabel('注册名称')"></label>
                              <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.bgiRegistname"
                                 readonly>
                              </el-input>
                           </el-form-item>
                           <el-form-item prop="bigLineClass" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                              <label slot="label" :style="$common.labelStyle('产品线分类')"
                                 v-html="$common.htmlLabel('产品线分类')"></label>
                              <div class="cmContent">
                                 <el-button v-if="dataActionBox.actionType != 2" class="cmButton"
                                    @click="openRange('产品线分类', 'manrange')" type="info" plain
                                    size="mini">选择产品线分类</el-button>
                                 <el-input type="textarea" style="width: 100%;" v-model="sendDataInfo.bigLineClass"
                                    readonly>
                                 </el-input>
                              </div>
                           </el-form-item>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
               @initActionBox="initActionBox" @sendDataAction="sendDataAction" :flag="false"
               :closeFlag="dataActionBox.actionType == 2 ? true : false"></v-foot>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 范围穿梭框 -->
      <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="90vw" :modal-append-to-body='true'
         id="csDia" :append-to-body="true" :before-close="handleClose">
         <div v-if="rangeTitle == '注册证'">
            <!-- 穿梭框 -->
                  <shuttle-table 
                     :dataList="transferTableData" 
                     @closeClick="handleClose"
                     @openClick="handleConfirm"
                  />
         </div>
         <block v-else>
            <div class="edit_dev">
               <!-- 注册证时显示表格样式的穿梭框 -->

               <!-- 其他情况使用默认样式 -->
               <el-transfer filterable target-order="push" :filter-method="filterMethod"
                  filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
               </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
               <el-button @click="handleClose">取 消</el-button>
               <el-button type="primary" @click="confirmRange">确 定</el-button>
            </span>
         </block>
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import shuttleTable from '@/byComponents/shuttleTable.vue'
import NP from "number-precision";
export default {
   name: "cusAuthAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      shuttleTable,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            cmCode: "",
            cmName: "",
            cmId: "",
            authStart: "",
            authEnd: "",
            customerName: "",//终端公司
            customerList: [],//终端公司列表
            bigLineClass: "",//产品线分类
            bigLineClassList: [],//产品线分类列表
            brandName: "",//品牌
            brandList: [],//品牌列表
            hospitalName: "",//医院
            areaName: "",//医院区域
            hospitalList: [],//医院列表
            bgiRegistno: "",//注册证号
            bgiRegistname: "",//注册证名称
            registnoList: [],//注册证号列表
            cmLevel: "",
         },
         showTabs: "",
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         seId: "",
         seType: "",
         seIndex: "",
         sField: "", // 赋值字段
         fField: "", //焦点字段
         parentSearchData: {},
         tabForm: [
            {
               jciName: "",
            }
         ], // tab循环的主表单
         footForm: [],
         inputel: [],
         dialogRange: false,
         transferData: [],
         transferTableData: {
            leftList: [],
            rightList: [],
            list: [],
            nameList: [
               { entityField: 'bgiRegistno', showField: '注册证号', fieldWeight: 150 },
               { entityField: 'manufacturer', showField: '生产厂家', fieldWeight: 150 },
               { entityField: 'bgiLineClass', showField: '产品线分类', fieldWeight: 150 }
            ]
         },
         rangeTitle: "",
         rangeValue: [],
         dataList: {
            bigLineClassList: [],//产品线分类列表
            customerList: [],//终端公司列表
            brandList: [],//品牌列表
            hospitalList: [],//医院列表
            registnoList: [],//注册证号列表
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'sendDataInfo.authStart'() {
         if (this.sendDataInfo.authEnd != "" && this.sendDataInfo.authEnd != null &&this.sendDataInfo.authStart != "" && this.sendDataInfo.authStart != null && this.sendDataInfo.authStart > this.sendDataInfo.authEnd) {
            this.sendDataInfo.authStart = "";
            return this.$message.error("起始日期不能大于结束日期");
         }
      },
      'sendDataInfo.authEnd'() {
         if (this.sendDataInfo.authStart != "" && this.sendDataInfo.authStart != null &&this.sendDataInfo.authEnd != "" && this.sendDataInfo.authEnd != null && this.sendDataInfo.authStart > this.sendDataInfo.authEnd) {
            this.sendDataInfo.authEnd = "";
            return this.$message.error("结束日期不能小于起始日期");
         }
      }
   },
   //方法集合
   methods: {
      clearChange() {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.$set(this.sendDataInfo, item, "")
         });
      },
      // 是否确认关闭
      handleClose(done) {
         this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.dialogRange = false;
            })
            .catch(() => { });
      },
      // 处理穿梭框确认
      handleConfirm(selectedData) {
         if (this.rangeTitle == '注册证') {
            this.sendDataInfo.registnoList = []
            let list = [];
            selectedData.forEach((item) => {
               list.push(item);
            });
            this.sendDataInfo.registnoList = selectedData.map(item => item.key);
            this.sendDataInfo.bgiRegistname = list.map(item => item.bgiRegistname || item.label).join();
            this.sendDataInfo.bgiRegistno = list.map(item => item.bgiRegistno || item.label).join();
            
            let bigLineClassList = [];
            list.forEach((item) => {
               var prlIdItem = this.dataList.bigLineClassList.find(sub => sub.bgiLineClass == item.bgiLineClass);
               if (prlIdItem) {
                  bigLineClassList.push(prlIdItem.prlId);
               }
            });
            this.sendDataInfo.bigLineClassList = bigLineClassList;
            this.sendDataInfo.bigLineClass = list.map(item => item.bgiLineClass).join();
         }
         this.dialogRange = false;
      },
      // 打开选择范围
      openRange(title, type) {
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               this.rangeValue = [];
               this.transferData = [];
               this.transferTableData = {
                  leftList: [],
                  rightList: [],
                  list: [],
                  nameList: [
                     { entityField: 'bgiRegistno', showField: '注册证号', fieldWeight: 150 },
                     { entityField: 'manufacturer', showField: '生产厂家', fieldWeight: 150 },
                     { entityField: 'bgiLineClass', showField: '产品线分类', fieldWeight: 150 }
                  ]
               };
               this.rangeTitle = title;
               if (this.rangeTitle == "终端公司") {
                  if (this.sendDataInfo.customerList.length > 0) {
                     this.rangeValue = this.sendDataInfo.customerList
                  }
                  this.dataList.customerList.forEach((item) => {
                     this.transferData.push({
                        label: item.cmName,
                        key: item.cmId,
                        pinyin: item.cmHemcode,
                     });
                  });
               } else if (this.rangeTitle == '产品线分类') {
                  if (this.sendDataInfo.bigLineClassList.length > 0) {
                     this.rangeValue = this.sendDataInfo.bigLineClassList
                  }
                  this.dataList.bigLineClassList.forEach((item) => {
                     this.transferData.push({
                        label: item.bgiLineClass,
                        key: item.prlId,
                        pinyin: item.bgiLineClass,
                     });
                  });
               } else if (this.rangeTitle == '品牌') {
                  if (this.sendDataInfo.brandList.length > 0) {
                     this.rangeValue = this.sendDataInfo.brandList
                  }
                  this.dataList.brandList.forEach((item) => {
                     this.transferData.push({
                        label: item.bgiBrand,
                        key: item.brandId,
                        pinyin: item.brandCode,
                     });
                  });

               } else if (this.rangeTitle == '医院') {
                  if (this.sendDataInfo.hospitalList.length > 0) {
                     this.rangeValue = this.sendDataInfo.hospitalList
                  }
                  this.dataList.hospitalList.forEach((item) => {
                     this.transferData.push({
                        label: item.name,
                        key: item.id,
                        pinyin: item.name,
                     });
                  });

               } else if (this.rangeTitle == '注册证') {
                  if (this.sendDataInfo.registnoList.length > 0) {
                     this.rangeValue = this.sendDataInfo.registnoList
                  }
                  this.dataList.registnoList.forEach((item) => {
                     this.transferTableData.leftList.push({
                        label: item.bgiRegistno,
                        key: item.regId,
                        pinyin: item.bgiRegistno,
                        bgiRegistno: item.bgiRegistno,
                        bgiRegistname: item.bgiRegistname,
                        manufacturer: item.manufacturer,
                        bgiLineClass: item.bgiLineClass
                     });
                     this.transferTableData.list.push({
                        label: item.bgiRegistno,
                        key: item.regId,
                        pinyin: item.bgiRegistno,
                        bgiRegistno: item.bgiRegistno,
                        bgiRegistname: item.bgiRegistname,
                        manufacturer: item.manufacturer,
                        bgiLineClass: item.bgiLineClass
                     });
                  });
                  this.transferTableData.rightList = [] // 已选中的数据
                  console.log(this.dataList.registnoList,this.transferData,'this.transferData11111111');
               }
               this.dialogRange = true;
            } else {
               this.$message({
                  message: "请完善主表单必填信息",
                  type: "error",
               });
               return false;
            }
         });

      },
      // 选择范围确定
      confirmRange() {
         var list = [];
         if (this.rangeTitle == '终端公司') {
            this.sendDataInfo.customerList = []
            this.dataList.customerList.forEach((item) => {
               var arr = this.rangeValue.filter(val => val == item.cmId);
               if (arr.length > 0) {
                  list.push(item);
               }
            });
            this.sendDataInfo.customerList = this.rangeValue
            this.sendDataInfo.customerName = list.map(item => item.cmName).join();
         } else if (this.rangeTitle == '产品线分类') {
            this.sendDataInfo.bigLineClassList = []
            this.dataList.bigLineClassList.forEach((item) => {
               var arr = this.rangeValue.filter(val => val == item.prlId);
               if (arr.length > 0) {
                  list.push(item);
               }
            });
            this.sendDataInfo.bigLineClassList = this.rangeValue
            this.sendDataInfo.bigLineClass = list.map(item => item.bgiLineClass).join();
         } else if (this.rangeTitle == '品牌') {
            this.sendDataInfo.brandList = []
            this.dataList.brandList.forEach((item) => {
               var arr = this.rangeValue.filter(val => val == item.brandId);
               if (arr.length > 0) {
                  list.push(item);
               }
            });
            this.sendDataInfo.brandList = this.rangeValue
            this.sendDataInfo.brandName = list.map(item => item.bgiBrand).join();
         } else if (this.rangeTitle == '医院') {
            this.sendDataInfo.hospitalList = []
            this.dataList.hospitalList.forEach((item) => {
               var arr = this.rangeValue.filter(val => val == item.id);
               if (arr.length > 0) {
                  this.sendDataInfo.hospitalList.push(item);
                  list.push(item);
               }
            });
            this.sendDataInfo.hospitalList = this.rangeValue
            this.sendDataInfo.hospitalName = list.map(item => item.name).join();
            this.sendDataInfo.areaName = list.map(item => item.area).join();
         } else if (this.rangeTitle == '注册证') {
            this.sendDataInfo.registnoList = []
            this.dataList.registnoList.forEach((item) => {
               var arr = this.rangeValue.filter(val => val == item.regId);
               if (arr.length > 0) {
                  list.push(item);
               }
            });
            this.sendDataInfo.registnoList = this.rangeValue
            this.sendDataInfo.bgiRegistname = list.map(item => item.bgiRegistname).join();
            this.sendDataInfo.bgiRegistno = list.map(item => item.bgiRegistno).join();
            // this.sendDataInfo.manufacturer = list.map(item => item.manufacturer).join();
            let bigLineClassList = [];
            console.log(this.dataList.bigLineClassList,'this.dataList.bigLineClassList111111');

            
            list.forEach((item) => {
               var prlIdItem = this.dataList.bigLineClassList.find(sub => sub.bgiLineClass == item.bgiLineClass);
                console.log(prlIdItem,'prlIdItem');
               if (prlIdItem) {
                  bigLineClassList.push(prlIdItem.prlId);
               }
            });
            console.log(list,bigLineClassList,'list1111111');
            this.sendDataInfo.bigLineClassList = bigLineClassList
            this.sendDataInfo.bigLineClass = list.map(item => item.bgiLineClass).join();
         }
         this.dialogRange = false;
      },
      // 过滤方法
      filterMethod(query, item) {
         if (query != '') {

            if (this.rangeTitle == '注册证'){
               // 构建搜索内容，包含三个字段
               let searchContent = '';
               if (item.bgiRegistno) searchContent += item.bgiRegistno;
               if (item.manufacturer) searchContent += item.manufacturer;
               if (item.bgiLineClass) searchContent += item.bgiLineClass;
               if (item.pinyin) searchContent += item.pinyin;
               if (item.label) searchContent += item.label;
               
               // 转换为小写进行搜索
               return searchContent.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }else{ 
               if (/^[a-zA-Z]*$/.test(query)) {
                  return item.pinyin.indexOf(query) > -1;
               }
               else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                  return item.label.indexOf(query) > -1;
               }
            }
         }
         return true;
      },
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'bgiType' || fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.sendDataInfo.authEnd = time;
         }
      },
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val && (val != "" || val != undefined)) {
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val, flag) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.$set(this.sendDataInfo, item, val[item])
         });
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.parentSearchData = {}
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type];
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },

      initActionBox(sendDataInfo) {
         if (this.actionData.cate == 2) {
            this.$emit("drawerCancel", 0);
            this.init();
            this.$refs.sendDataInfo.resetFields();
            return
         }
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
               // this.$message({
               //     type: 'info',
               //     message: '取消关闭'
               // });
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.customerList = []
         this.sendDataInfo.bigLineClassList = []
         this.sendDataInfo.brandList = []
         this.sendDataInfo.hospitalList = []
         this.sendDataInfo.registnoList = []
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         var oldData = this.actionData.oldData;
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.sendDataInfo.id = dataInfo.id
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         //产品线分类
         if (this.sendDataInfo.bigLineClassList && this.sendDataInfo.bigLineClassList != null && this.sendDataInfo.bigLineClassList.length > 0) {
            this.sendDataInfo.bigLineClass = this.sendDataInfo.bigLineClassList.map(item => item.bgiLineClass).join();
            this.sendDataInfo.bigLineClassList = this.sendDataInfo.bigLineClassList.map(item => item.id)
         }
         //终端公司
         if (this.sendDataInfo.customerList && this.sendDataInfo.customerList != null && this.sendDataInfo.customerList.length > 0) {
            this.sendDataInfo.customerName = this.sendDataInfo.customerList.map(item => item.cmName).join();
            this.sendDataInfo.customerList = this.sendDataInfo.customerList.map(item => item.cmId)
         }
         //品牌
         if (this.sendDataInfo.brandList && this.sendDataInfo.brandList != null && this.sendDataInfo.brandList.length > 0) {
            this.sendDataInfo.brandName = this.sendDataInfo.brandList.map(item => item.bgiBrand).join();
            this.sendDataInfo.brandList = this.sendDataInfo.brandList.map(item => item.brandId)
         }
         //医院列表
         if (this.sendDataInfo.hospitalList && this.sendDataInfo.hospitalList != null && this.sendDataInfo.hospitalList.length > 0) {
            this.sendDataInfo.hospitalName = this.sendDataInfo.hospitalList.map(item => item.name).join();
            this.sendDataInfo.areaName = this.sendDataInfo.hospitalList.map(item => item.area).join();
            this.sendDataInfo.hospitalList = this.sendDataInfo.hospitalList.map(item => item.id)
         }
         //注册证号列表
         if (this.sendDataInfo.registnoList && this.sendDataInfo.registnoList != null && this.sendDataInfo.registnoList.length > 0) {
            this.sendDataInfo.bgiRegistname = this.sendDataInfo.registnoList.map(item => item.bgiRegistname).join();
            this.sendDataInfo.bgiRegistno = this.sendDataInfo.registnoList.map(item => item.bgiRegistno).join();
            this.sendDataInfo.registnoList = this.sendDataInfo.registnoList.map(item => item.regId)
         }
         this.$nextTick(() => {
            setTimeout(() => {
               this.initFocus();
            }, 16.7);
         });
      },
      sendDataAction(sendDataInfo) {
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               this.$refs.sendDataInfo1.validate((valid1) => {
                  if (valid1) {
                     this.sub()
                  } else {
                     this.$message({
                        message: "请完善必填信息",
                        type: "error",
                     });
                     return false;
                  }
               });
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.baseauthadd(sendData);
         } else {
            var responseData = await this.$http.baseauthupdate(sendData);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message.success("操作成功");
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 输入框切换焦点
      nextFocus(index, fField) {
         if (fField == "keydown") {
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },
      // 获取产品线列表
      async baseprolinequery() {
         let responseData = await this.$http.baseprolinequery({ prlName: "", bgiLineClass: "", page: 1, rows: 10000 });
         if (responseData.status == 200) {
            this.dataList.bigLineClassList = responseData.result.list;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取产品线列表
      async baseauthqueryCustomerList() {
         let responseData = await this.$http.baseauthqueryCustomerList({});
         if (responseData.status == 200) {
            this.dataList.customerList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取品牌列表
      async baseauthqueryBrandList() {
         let responseData = await this.$http.baseauthqueryBrandList({});
         if (responseData.status == 200) {
            this.dataList.brandList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取医院列表
      async baseauthqueryHospitalList() {
         let responseData = await this.$http.baseauthqueryHospitalList({});
         if (responseData.status == 200) {
            this.dataList.hospitalList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取注册号列表
      async baseauthqueryRegistnoList() {
         let responseData = await this.$http.baseauthqueryRegistnoList({});
         if (responseData.status == 200) {
            this.dataList.registnoList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.baseprolinequery()//获取产品线列表
      this.baseauthqueryCustomerList()//获取终端客户列表
      this.baseauthqueryBrandList()//获取品牌列表
      this.baseauthqueryHospitalList()//获取医院列表
      this.baseauthqueryRegistnoList()//获取注册号列表
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}

.table_content_box {
   padding-bottom: 50px;
}

::v-deep .el-form-item--mini .el-form-item__content {
   width: calc(100% - 100px) !important;
}

::v-deep .baseForm .el-textarea__inner {
   width: 100% !important;
}

/* 表格样式的穿梭框 */
.transfer-with-header {
   position: relative;
}

/* 表格行 */
.transfer-table-row {
   display: flex;
   padding: 8px 12px;
   border-bottom: 1px solid #f0f0f0;
}

.table-cell {
   flex: 1;
   text-align: left;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

/* 调整选择框位置 */
::v-deep .el-transfer-panel__item {
   padding: 0 !important;
}

::v-deep .el-checkbox {
   margin: 8px 12px;
}

/* 调整面板高度和样式 */
::v-deep .el-transfer {
   height: 400px;
}

/* 调整面板内容高度 */
::v-deep .transfer-with-header .el-transfer-panel__body {
   height: 360px !important;
}
</style>